
import * as _ from 'lodash-es'
import { base } from './base'

export const environment = _.extend(base, {
  production: true,
  API_HOST: 'api.nexedu.com.ar',
  API_URL: 'https://api.nexedu.com.ar',
  V2_API_URL: 'https://api.nexedu.com.ar/v2',
  CLOUDINARY: {
    CLOUD_NAME : 'nexedu-prod2',
    TENANTS_PRESET: 'tenants',
    IMPORTS_PRESET: 'imports',
    ATTACHMENTS_PRESET: 'attachments',
    ALBUMS_PRESET: 'albums'
  },
  KEEN: {
    PROJECT_ID: '',
    KEY: ''
  },
  AMPLITUDE: {
    API_KEY: '34dd93fa6166e75ea85c19e5042f69fa',
    ENVIRONMENT: 'production'
  }
})
